import { transcripts } from './transcripts';
import { workspaces } from './workspaces';
import { projects } from './projects';

export const queryKeys = {
  transcripts,
  workspaces,
  projects,
};
